"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnthropicModelModel = void 0;
exports.AnthropicModelModel = {
    Claude3Opus20240229: "claude-3-opus-20240229",
    Claude3Sonnet20240229: "claude-3-sonnet-20240229",
    Claude3Haiku20240307: "claude-3-haiku-20240307",
    Claude35Sonnet20240620: "claude-3-5-sonnet-20240620",
    Claude35Sonnet20241022: "claude-3-5-sonnet-20241022",
    Claude35Haiku20241022: "claude-3-5-haiku-20241022",
};
